/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PriceColumns {
    FROM_DATE = 'from_date',
    TO_DATE = 'to_date',
    ASKING_RENT = 'asking_rent',
    EFFECTIVE_RENT = 'effective_rent',
    ASKING_RENT_PSF = 'asking_rent_psf',
    EFFECTIVE_RENT_PSF = 'effective_rent_psf',
    CONCESSION = 'concession',
    AS_OF_WEEK = 'as_of_week',
    AS_OF_MONTH = 'as_of_month',
    AS_OF_QUARTER = 'as_of_quarter',
    LEASE_START_DATE = 'lease_start_date',
    LEASE_END_DATE = 'lease_end_date',
    LEASE_TERM = 'lease_term',
    LEASED_ASKING_RENT = 'leased_asking_rent',
    LEASED_EFFECTIVE_RENT = 'leased_effective_rent',
    LEASED_ASKING_RENT_PSF = 'leased_asking_rent_psf',
    LEASED_EFFECTIVE_RENT_PSF = 'leased_effective_rent_psf',
    LEASED_CONCESSION = 'leased_concession',
}
